import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
    typography: {
      fontFamily: "'Lato', sans-serif",
    },
  });

  export default theme;